/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import JsonQuery from 'json-query';
import parse from 'parse-json';
import { hooks as commonHooks, types as commonTypes } from '@sitebuilder/common';
import {
    getTextSchemaProperties,
    getStyleSchemaProperties,
    getLayoutSchemaProperties,
} from '../utils';
import listDocumentStyles, { listDocumentThemeStyles } from './ListDocuments.styles';

interface ListDocumentsProps {
    dataKey: string;
    link: string;
    linkName: string;
    linkIcon?: string;
    isImgLink?: boolean;
    imageLink?: string;
    altText: string;
    imgFileName?: string;
    imgFileType?: string;
    openInNewTab?: boolean;
    typographyClass?: string;
}

interface WidgetProperties extends commonTypes.WidgetPropertiesBase, ListDocumentsProps {}

const ListDocuments = (props: commonTypes.WidgetInstanceProps) => {
    const widgetProperties = commonHooks.useWidgetProperties<WidgetProperties>(
        props.widgetInstanceId
    );
    const {
        styles,
        dataKey,
        link,
        linkName,
        linkIcon,
        isImgLink,
        imageLink,
        altText,
        imgFileName,
        openInNewTab,
    } = widgetProperties || {};

    const { data } = props;
    const theme = data?.themeSelected || props?.theme;
    const { value: documentListJSON }: any = JsonQuery(`${dataKey}`, { data });

    const documentList: any = Array.isArray(documentListJSON)
        ? parse(JSON.stringify(documentListJSON))
        : [];

    return (
        <>
            {documentList?.length > 0 && (
                <ul
                    className={`list-document-container ${
                        widgetProperties?.typographyClass ? widgetProperties.typographyClass : ''
                    }`}
                    data-testid={'list-document-container'}
                    css={css`
                        ${!theme
                            ? listDocumentStyles
                            : listDocumentThemeStyles}${getTextSchemaProperties(
                            widgetProperties,
                            data?.colorSpace
                        )}${getStyleSchemaProperties(widgetProperties)}${getLayoutSchemaProperties(
                            widgetProperties
                        )}${styles || ''}
                    `}
                >
                    {documentList.map((doc: any, index: number) => (
                        <li key={index} className="document">
                            {isImgLink && (
                                <img
                                    className="document-image"
                                    // eslint-disable-next-line max-len
                                    src={`${imageLink}/${
                                        (imgFileName && doc[imgFileName]) || imgFileName
                                    }`}
                                    alt={doc[altText]}
                                />
                            )}
                            {linkIcon && linkIcon.length > 1 && (
                                <i className={`link-icon ${linkIcon}`}></i>
                            )}
                            <a
                                href={doc[link]}
                                className="document-link"
                                rel="noreferrer"
                                tabIndex={0}
                                target={openInNewTab ? '_blank' : '_self'}
                            >
                                {doc[linkName]}
                            </a>
                        </li>
                    ))}
                </ul>
            )}
        </>
    );
};

export default ListDocuments;
